const enum Frequency { MONTHLY = 'monthly', ONCE = 'once'}

export default Frequency;